import { action, makeObservable, observable, runInAction } from 'mobx';

import { injectable } from '@servicetitan/react-ioc';

export interface ToastNotification {
    status: 'info' | 'critical' | 'success' | 'warning';
    title: string;
    message: string;
}

export interface ToastItem {
    key: number;
    notification: ToastNotification;
    handleClose: () => void;
}

export interface SnackbarItem {
    key: number;
    title: string;
    handleClose: () => void;
}

@injectable()
export class NotificationCenterStore {
    @observable.ref toastItems: ToastItem[] = [];
    @observable.ref snackbarItems: SnackbarItem[] = [];

    private nextKey = 0;

    constructor() {
        makeObservable(this);
    }

    @action
    addToast(notification: ToastNotification): void {
        const key = this.nextKey;
        this.toastItems = [
            {
                key,
                notification,
                handleClose: () => {
                    runInAction(() => {
                        this.toastItems = this.toastItems.filter(item => item.key !== key);
                    });
                },
            },
            ...this.toastItems,
        ];
        this.nextKey++;
    }

    @action
    addSnackbar(title: string): void {
        const key = this.nextKey;
        this.snackbarItems = [
            {
                key,
                title,
                handleClose: () => {
                    runInAction(() => {
                        this.snackbarItems = this.snackbarItems.filter(item => item.key !== key);
                    });
                },
            },
            ...this.snackbarItems,
        ];
        this.nextKey++;
    }
}
